import React from "react"
import {Route} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"
import TeamsLink from "../containers/TeamsLink"

interface Props {
  path: string
}

const Bots = (props: Props) => {
  const {path} = props

  return (
    <Route path={path}>
      <>
        <NestedRoute match={path} path="/teams/link" component={TeamsLink} />
      </>
    </Route>
  )
}

export default Bots
